"use client";

import React from "react";
import { FiDatabase, FiExternalLink } from "react-icons/fi";
import styles from "./CardList.module.css";
import { useSources } from "./useSources";
import SourceCard from "./SourceCard";
import SourceCardSkeleton from "./SourceCardSkeleton";

const LatestSource: React.FC = () => {
  const { sources, isFirstLoad, newItemId } = useSources();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}><FiDatabase size={18} /> Latest sources</h3>
        <a
          href="https://management.opengpu.network/sources"
          className={styles.viewAll}
          target="_blank"
          rel="noopener noreferrer"
        >
          View all sources <FiExternalLink size={14} />
        </a>
      </div>
      <div
        className={`${styles.cardList} ${isFirstLoad ? "" : styles.fadeIn}`}
      >
        {sources.length > 0
          ? sources.map((source) => (
              <SourceCard
                key={source._id.$oid}
                source={source}
                isNew={source._id.$oid === newItemId}
              />
            ))
          : Array.from({ length: 3 }).map((_, i) => (
              <SourceCardSkeleton key={i} />
            ))}
      </div>
    </div>
  );
};

export default LatestSource;
